import { Component, OnInit } from '@angular/core';
import { BaseDynamicViewComponent } from 'src/app/common/components/dynamic-view-v2/components/base-dynamic-form/base-dynamic-view.component';
import { DynamicCardType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicCardType';
import { DynamicViewType } from 'src/app/common/components/dynamic-view-v2/enums/DynamicViewType';
import BaseEntityDto from 'src/app/common/dtos/BaseEntityDto';
import { BaseViewFieldType } from 'src/app/common/components/dynamic-view-v2/enums/BaseViewFieldType';

@Component({
  selector: 'app-qa-users-views-v2',
  templateUrl: './qa-users-views-v2.component.html',
  styleUrls: ['./qa-users-views-v2.component.sass']
})
export class QAUsersViewsV2Component  extends BaseDynamicViewComponent implements OnInit
{
  QAUserRecord: BaseEntityDto = new BaseEntityDto();
  constructor()
  {
    super();
  }

  /**
   * Titles View V2 Initial Implementation
   */
  ngOnInit()
  {
    this.fields =
    [
      {
        title: "QA User Details",
        fields:
        [
          { name: "Identifier", inputType: DynamicViewType.BaseViewField , viewTypes: [BaseViewFieldType.Text], clearField: true, key: 'identifier', isRequired: true, label: 'Identifier' },
          { name: "Internal Identifier", inputType: DynamicViewType.BaseViewField , viewTypes: [BaseViewFieldType.Text], clearField: true, key: 'internalIdentifier', label: 'Internal Identifier' },
        ],
        type: DynamicCardType.Card
      },

    ]
    // This will help us to define fields
    // with pre-established values.
    // This is just an example, there is no
    // need to add it if it's not necessary.
    this.QAUserRecord =
    {
      enabled: false
    };
    this.title = "QA Users";
    this.viewRoute = 'qa-users-v2';
    this.isLoading = false;
  }

}
